import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Data table
import { Skeletonitems, SkeletonbodyTemplate, otherMasterTypes } from '../../../../appconfig/Settings';

import { deleteDataWithParameters, getAllDetailsDirect, postAllData } from '../../../../service/ProductService';
import { DOCUMENTS, OTHERMASTER, UPDATE_DOCUMENTS, UPDATE_OTHERMASTER } from '../../../../config/ApiConstant';
import { AddDocumentMasterListColumns, OtherMasterColumns } from '../../../../appconfig/DatatableSetting';
import { Dialog } from 'primereact/dialog';
import { addDocumentMasterValidate } from '../../../../config/Validate';
import AppBreadcrumb from '../../../../components/CustomeBreadcrumb/AppBreadcrumb';

export const AddDocument = () => {
    document.title = 'Add Document | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [documentName, setDocumentName] = useState<any>();
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [documentMasterList, setDocumentMasterList] = useState<any>([]);
    const [errors, setErrors] = useState<any>({});
    const [editId, setEditId] = useState<any>(null);

    //delete
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        getDocumentMasterData();
    }, []);

    // Add application bill master
    const addDocumentMaster = async () => {
        try {
            const { errors, isError } = addDocumentMasterValidate(documentName);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setSubmitLoading(true);

                let requestData: any = {
                    DocName: documentName
                };

                //API URL
                let apiUrl = DOCUMENTS;

                //Check Add/Edit then Put in Request
                if (!window.cn(editId)) {
                    requestData['SrNo'] = editId;
                    apiUrl = UPDATE_DOCUMENTS;
                }

                const response = await postAllData(apiUrl, requestData);
                if (response) {
                    setSubmitLoading(false);
                    setDocumentName('');
                    setEditId(null);
                    setErrors({});
                    getDocumentMasterData();
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.data });
                }
            }
        } catch (error: any) {
            setPageLoad(true);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all application bills
    const getDocumentMasterData = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetailsDirect(DOCUMENTS);

            //Check response
            if (response) {
                setDocumentMasterList(response);
                setPageLoad(true);
            }
        } catch (error: any) {
            if (error.response) {
                setPageLoad(true);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    // Template for action
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="flex">
                    <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="p-button-rounded" onClick={() => openEditModal(rowData)} />
                    <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger p-button-rounded ml-2" onClick={() => openDeleteModal(rowData?.SrNo)} />
                </div>
            </>
        );
    };

    //editDara
    const openEditModal = (rowData: any) => {
        setEditId(rowData?.SrNo);
        setDocumentName(rowData?.DocName);
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setEditId(null);
        setErrors({});
        setDocumentName('');
    };

    // Open delete modal
    const openDeleteModal = (index: any) => {
        setDeleteId(index);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteModal(false);
    };

    // Delete application
    const deleteApplication = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteDataWithParameters(DOCUMENTS + '?SrNo=' + deleteId);
            if (response) {
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.data
                });
                getDocumentMasterData();
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Master'} pageName={"Add Document"} pageTitle={"Add Document"} goToPage={true}/>

            <Toast ref={toast} />
            <div className="card mt-4">
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-8">
                        <label htmlFor="documentName">Document Name</label>
                        <div className="input-effect-div">
                            <InputText value={documentName} name="documentName" autoComplete="off" onChange={(e) => setDocumentName(e.target.value)} className={errors['documentName'] && 'p-invalid'} />
                        </div>
                        <small className="p-invalid-txt">{errors['documentName']}</small>
                    </div>
                    <div className="field col-12 md:col-4">
                        <Button style={{ width: 'fit-content', marginTop: '25px' }} label={!window.cn(editId) ? 'EDIT' : 'ADD'} icon="pi pi-check" onClick={() => addDocumentMaster()} loading={submitLoading} />
                    </div>
                </div>
            </div>

            <div className="card">
                {/* Datatable */}
                {pageLoad ? (
                    <>
                        <DataTable
                            value={documentMasterList}
                            showGridlines
                            stripedRows
                            globalFilter={globalFilter}
                            filters={globalFieldFilter}
                            onFilter={(e) => setGlobalFieldFilter(e.filters)}
                            className="datatable-responsive "
                            emptyMessage="No Data Found"
                        >
                            {AddDocumentMasterListColumns.map((col, i) => {
                                if (col.field === 'sr_no') {
                                    return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;
                                } else if (col.field === 'action') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                } else {
                                    return <Column key={col.field} field={col.field} header={col.header} />;
                                }
                            })}
                        </DataTable>
                    </>
                ) : (
                    <>
                        {/* Skeleton Data table */}
                        <DataTable value={Skeletonitems}>
                            {AddDocumentMasterListColumns.map((col, i) => (
                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                            ))}
                        </DataTable>
                    </>
                )}
            </div>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Document"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteApplication} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Document, This will be deleted permentatly.</span>
                </div>
            </Dialog>
        </>
    );
};
